// extracted by mini-css-extract-plugin
export var container = "ArticleCard-module--container--rODSf";
export var date = "ArticleCard-module--date--+J3Km";
export var featuredContainer = "ArticleCard-module--featuredContainer--8T6sY";
export var image = "ArticleCard-module--image--nyQre";
export var limitWidthOnLargeScreens = "ArticleCard-module--limitWidthOnLargeScreens--Yp6Sa";
export var right = "ArticleCard-module--right--mugCw";
export var summary = "ArticleCard-module--summary--h0igq";
export var title = "ArticleCard-module--title--p89Kt";